module.exports = __webpack_public_path__ + "static/media/pets-allowed.1f51d924.png";